import { isArray, isNil, isString } from '@antv/util';
// todo è¿ä¸ªå°åºç®çæ¯ä»ä¹ï¼
var toScaleString = function (scale, value) {
    if (isString(value)) {
        return value;
    }
    return scale.invert(scale.scale(value));
};
/**
 * ææè§è§ééå±æ§çåºç±»
 * @class Base
 */
var Attribute = /** @class */ (function () {
    function Attribute(cfg) {
        this.names = [];
        this.scales = [];
        this.linear = false;
        this.values = [];
        this.callback = function () { return []; };
        // è§£æéç½®
        this._parseCfg(cfg);
    }
    /**
     * æ å°çå¼ç»æçæ°ç»
     * @param params å¯¹åº scale é¡ºåºçå¼ä¼ å¥
     */
    Attribute.prototype.mapping = function () {
        var _this = this;
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        var values = params.map(function (param, idx) {
            return _this._toOriginParam(param, _this.scales[idx]);
        });
        return this.callback.apply(this, values);
    };
    /**
     * å¦æè¿è¡çº¿æ§æ å°ï¼è¿åå¯¹åºçæ å°å¼
     * @param percent
     */
    Attribute.prototype.getLinearValue = function (percent) {
        // åæ®µæ°é
        var steps = this.values.length - 1;
        var step = Math.floor(steps * percent);
        var leftPercent = steps * percent - step;
        // todo ä¸æè¿ä¸ªé»è¾
        var start = this.values[step];
        var end = step === steps ? start : this.values[step + 1];
        // çº¿æ§æ¹ç¨
        return start + (end - start) * leftPercent;
    };
    /**
     * æ ¹æ®åº¦éè·åå±æ§å
     */
    Attribute.prototype.getNames = function () {
        var scales = this.scales;
        var names = this.names;
        var length = Math.min(scales.length, names.length);
        var rst = [];
        for (var i = 0; i < length; i += 1) {
            rst.push(names[i]);
        }
        return rst;
    };
    /**
     * è·åææçç»´åº¦å
     */
    Attribute.prototype.getFields = function () {
        return this.scales.map(function (scale) { return scale.field; });
    };
    /**
     * æ ¹æ®åç§°è·ååº¦é
     * @param name
     */
    Attribute.prototype.getScale = function (name) {
        return this.scales[this.names.indexOf(name)];
    };
    /**
     * é»è®¤çåè°å½æ°ï¼ç¨æ·æ²¡æèªå®ä¹ callbackï¼æèç¨æ·èªå®ä¹ callback è¿åç©ºçæ¶åï¼ä½¿ç¨ values æ å°ï¼
     * @param params
     */
    Attribute.prototype.defaultCallback = function () {
        var _this = this;
        var params = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            params[_i] = arguments[_i];
        }
        // æ²¡æ params çæåµï¼æ¯ææ²¡ææå® fieldsï¼ç´æ¥è¿åéç½®ç values å¸¸é
        if (params.length === 0) {
            return this.values;
        }
        return params.map(function (param, idx) {
            var scale = _this.scales[idx];
            return scale.type === 'identity' ? scale.values[0] : _this._getAttributeValue(scale, param);
        });
    };
    // è§£æéç½®
    Attribute.prototype._parseCfg = function (cfg) {
        var _this = this;
        var _a = cfg.type, type = _a === void 0 ? 'base' : _a, _b = cfg.names, names = _b === void 0 ? [] : _b, _c = cfg.scales, scales = _c === void 0 ? [] : _c, _d = cfg.values, values = _d === void 0 ? [] : _d, callback = cfg.callback;
        this.type = type;
        this.scales = scales;
        this.values = values;
        this.names = names;
        // æé  callback æ¹æ³
        this.callback = function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            /**
             * å½ç¨æ·è®¾ç½®ç callback è¿å null æ¶, åºè¯¥è¿åé»è®¤ callback ä¸­çå¼
             */
            if (callback) {
                // ä½¿ç¨ç¨æ·è¿åçå¼å¤ç
                var ret = callback.apply(void 0, params);
                if (!isNil(ret)) {
                    return [ret];
                }
            }
            // æ²¡æ callback æèç¨æ· callback è¿åå¼ä¸ºç©ºï¼åä½¿ç¨é»è®¤çé»è¾å¤ç
            return _this.defaultCallback.apply(_this, params);
        };
    };
    // è·åå±æ§å¼ï¼å°å¼æ å°å°è§è§éé
    Attribute.prototype._getAttributeValue = function (scale, value) {
        // å¦ææ¯éçº¿æ§çå­æ®µï¼ç´æ¥ä» values ä¸­åå¼å³å¯
        if (scale.isCategory && !this.linear) {
            // ç¦»æ£ scale åæ¢æç´¢å¼
            var idx = scale.translate(value);
            return this.values[idx % this.values.length];
        }
        // çº¿æ§åä½¿ç¨çº¿æ§å¼
        var percent = scale.scale(value);
        return this.getLinearValue(percent);
    };
    /**
     * éè¿ scale æ¿å°æ°æ®å¯¹åºçåå§çåæ°
     * @param param
     * @param scale
     * @private
     */
    Attribute.prototype._toOriginParam = function (param, scale) {
        // æ¯çº¿æ§ï¼ç´æ¥è¿å
        // éçº¿æ§ï¼ä½¿ç¨ scale åæ¢
        return !scale.isLinear
            ? isArray(param)
                ? param.map(function (p) { return toScaleString(scale, p); })
                : toScaleString(scale, param)
            : param;
    };
    return Attribute;
}());
export default Attribute;
//# sourceMappingURL=base.js.map